/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import UiJsonApiClient from "../../Basis/Api/UiJsonApiClient";
import Land from "./Land";
import Region from "./Region";

export type ErmittleRegionenInput = {
    landIso: string,
}

export default class LaenderClient extends UiJsonApiClient {
    public static readonly controllerName = "Laender";

    public constructor() {
        super(LaenderClient.controllerName);
    }

    public async ermittleRegionen(urlArguments: ErmittleRegionenInput): Promise<Region[]> {
        return await this.get<Region[]>("ErmittleRegionen", urlArguments);
    }

    public async ermittleLaender(): Promise<Land[]> {
        const laender = await this.get<Land[]>("ErmittleLaender");
        return laender;
    }
}